export const blockIconsPrivacyandsecurityBadgeNew = (
	<span className='material-symbols-outlined'>badge</span>
);
